export * from './lib/copy-to-clipboard.component.module';
